module.exports = __webpack_public_path__ + "static/media/view3.4d520a30.jpg";